import React,{ Component } from 'react';
import { Card, CardBody, CardTitle, UncontrolledTooltip } from 'reactstrap';
import Graph from 'react-chartist';

import { generateGUID  } from '../../../shared/utils';

import chartistLabelsPlugin from '../chartistLabelsPlugin';

class AudienceBarChart extends Component {
  constructor(){
    super();

    this.state = {
      randomId:generateGUID(),
      isGraphLoaded:false
    };
  }

  componentDidMount(){
    this.showToolTips();
    window.addEventListener('resize',() => {
      this.showToolTips()
    });
  }

  showToolTips(){
    this.setState({isGraphLoaded:false});

    //DELAY THIS SO TOOLTIPS CAN RENDER
    window.setTimeout(() => this.setState({isGraphLoaded:true}),500);
  }

  shouldComponentUpdate(nextProps,nextState){
    return this.state.isGraphLoaded !== nextState.isGraphLoaded
  }


  render(){
    return (
      <Card>
        <CardBody>
          <CardTitle>
            {this.props.title.toUpperCase()}
          </CardTitle>
          <Graph 
            className={this.props.wide ?'chart-wide':''}
            type='Bar' 
            options={{
              high:Math.max(...this.props.values) < 50 ? 60 : 100,
              low:0,
              scaleMinSpace:20,
              plugins:[
                chartistLabelsPlugin({
                  idPrefix:`bar_${this.state.randomId}`
                })
              ]
            }}
            data={{
              labels:this.props.labels,
              series:[
                this.props.values
              ]
            }}
          />
          {this.state.isGraphLoaded && (
            <div>
              {this.props.values.map((val,index) => (
                <UncontrolledTooltip
                  key={index} 
                  target={`bar_${this.state.randomId}_${val}`}
                  placement='top'
                  className='BarChartTooltip'
                >
                  <span className='label'>{this.props.labels[index]}<br /></span><span className='value'>&nbsp;{val}%</span>
                </UncontrolledTooltip>
              ))} 
            </div>
          )}
        </CardBody>
      </Card>
    );
  }
}

AudienceBarChart.defaultProps = {
  title:'',
  labels:[],
  values:[],
  wide:false
}

export default AudienceBarChart;


// WEBPACK FOOTER //
// ./src/routes/DabblAudience/components/AudienceBarChart.js